import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import FooterDefault from './Default';

class ServiceFooter extends React.Component {
  static propTypes = {
    footer: PropTypes.shape({
      html: PropTypes.arrayOf(
        PropTypes.string,
      ),
    }).isRequired,
  }

  shouldComponentUpdate() {
    return false;
  }

  hasFooter = () => {
    const { footer } = this.props;
    return footer && footer.html && footer.html.length;
  }

  render() {
    if (!this.hasFooter()) {
      return <FooterDefault />;
    }

    const {
      footer: {
        css: { link: links },
        html: [footer],
      } = {},
    } = this.props;

    return (
      <>
        {/* Attach stylesheets */}
        <Head>
          {links && Array.isArray(links)
            && links.map((href) => (
              <link key={href} href={href} rel="stylesheet" />
            ))}
        </Head>

        {/* Insert footer html markup */}
        <div
          id="hfs-footer"
          dangerouslySetInnerHTML={{ __html: footer }}
        />
      </>
    );
  }
}

export default ServiceFooter;
